import React from "react";
import { Route, Switch } from "react-router-dom";

import Add from "./Add";
import List from "./List";
import Edit from "./Edit";
import Summary from "./Summary";
import Upload from "./Upload";

import StrGrAdd from "./str_gr/Add";
import StrGrEdit from "./str_gr/Edit";
import StrGrSummary from "./str_gr/Summary";

import StrRmAdd from "./str_rm/Add";
import StrRmAddBySelection from "./str_rm/AddBySelection";
import StrRmEdit from "./str_rm/Edit";
import StrRmSummaryWithItems from "./str_rm/SummaryWithItems";
import StrRmPendingLineList from "./str_rm/PendingLineList";
import StrRmVerify from "./str_rm/Verify";
import StrRmList from "./str_rm/List";
import StrUpload from "./str_rm/Upload";
import StrRmHistory from "./str_rm/History";
import StrRmDocument from "./str_rm/Document";


import PrymAdd from "./prym/Add";
import PrymEdit from "./prym/Edit";
import PrymSummaryWithItems from "./prym/SummaryWithItems";
import PrymPendingLineList from "./prym/PendingLineList";
import PrymVerify from "./prym/Verify";
import PrymList from "./prym/List";
import PrymSummary from "./prym/Summary";
import PrymUpload from "./prym/Upload";

import OtrAdd from "./otr/Add";
import OtrEdit from "./otr/Edit";
import OtrSummaryWithItems from "./otr/SummaryWithItems";
import OtrPendingLineList from "./otr/PendingLineList";
import OtrVerify from "./otr/Verify";
import OtrList from "./otr/List";
import OtrUpload from "./otr/Upload";

import TiepAdd from "./tiep/Add";
import TiepEdit from "./tiep/Edit";
import TiepSummaryWithItems from "./tiep/SummaryWithItems";
import TiepPendingLineList from "./tiep/PendingLineList";
import TiepVerify from "./tiep/Verify";
import TiepList from "./tiep/List";
import TiepUpload from "./tiep/Upload";

import AquaAdd from "./aqua/Add";
import AquaEdit from "./aqua/Edit";
import AquaSummaryWithItems from "./aqua/SummaryWithItems";
import AquaPendingLineList from "./aqua/PendingLineList";
import AquaVerify from "./aqua/Verify";
import AquaList from "./aqua/List";
import AquaUpload from "./aqua/Upload";
import AquaHistory from "./aqua/History";
import AquaDocument from "./aqua/Document";

import { Auth } from "_helpers";

function MaterialRequests({ match }) {
  const { path } = match;
  const loggedInCustomerCode = Auth.getProfile().comp_code;
  if (loggedInCustomerCode === "STR_GR") {
    return (
      <Switch>
        <Route exact path={path} component={List} />
        <Route path={`${path}/add`} component={StrGrAdd} />
        <Route path={`${path}/upload`} component={Upload} />
        <Route path={`${path}/:id/edit`} component={StrGrEdit} />
        <Route path={`${path}/:id/summary`} component={StrGrSummary} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "STR") {
    return (
      <Switch>
        <Route exact path={path} component={StrRmList} />
        <Route path={`${path}/add`} component={StrRmAdd} />
        <Route
          path={`${path}/add-with-items`}
          component={StrRmAddBySelection}
        />
        <Route path={`${path}/upload`} component={StrUpload} />
        <Route path={`${path}/pending`} component={StrRmPendingLineList} />
        <Route path={`${path}/:id/edit`} component={StrRmEdit} />
        <Route path={`${path}/:id/summary`} component={StrRmSummaryWithItems} />
        <Route path={`${path}/:id/prepare`} component={StrRmVerify} />
        <Route path={`${path}/:id/history`} component={StrRmHistory} />
        <Route path={`${path}/:id/documents`} component={StrRmDocument} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "PRYM") {
    return (
      <Switch>
        <Route exact path={path} component={PrymList} />
        <Route path={`${path}/add`} component={PrymAdd} />
        <Route path={`${path}/upload`} component={PrymUpload} />
        <Route path={`${path}/:id/edit`} component={PrymEdit} />
        <Route path={`${path}/:id/summary`} component={PrymSummaryWithItems} />
        <Route path={`${path}/:id/verify`} component={PrymVerify} />
        <Route path={`${path}/pending`} component={PrymPendingLineList} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "OTR") {
      return (
          <Switch>
              <Route exact path={path} component={OtrList} />
              <Route path={`${path}/add`} component={OtrAdd} />
              <Route path={`${path}/upload`} component={OtrUpload} />
              <Route path={`${path}/:id/edit`} component={OtrEdit} />
              <Route path={`${path}/:id/summary`} component={OtrSummaryWithItems} />
              <Route path={`${path}/:id/verify`} component={OtrVerify} />
              <Route path={`${path}/pending`} component={OtrPendingLineList} />
          </Switch>
      );
  } else if (loggedInCustomerCode === "TIEP") {
      return (
          <Switch>
              <Route exact path={path} component={TiepList} />
              <Route path={`${path}/add`} component={TiepAdd} />
              <Route path={`${path}/upload`} component={TiepUpload} />
              <Route path={`${path}/:id/edit`} component={TiepEdit} />
              <Route path={`${path}/:id/summary`} component={TiepSummaryWithItems} />
              <Route path={`${path}/:id/verify`} component={TiepVerify} />
              <Route path={`${path}/pending`} component={TiepPendingLineList} />
          </Switch>
      );
  } else if (loggedInCustomerCode === "AQUA") {
    return (
        <Switch>
            <Route exact path={path} component={AquaList} />
            <Route path={`${path}/add`} component={AquaAdd} />
            <Route path={`${path}/upload`} component={AquaUpload} />
            <Route path={`${path}/:id/edit`} component={AquaEdit} />
            <Route path={`${path}/:id/summary`} component={AquaSummaryWithItems} />
            <Route path={`${path}/:id/verify`} component={AquaVerify} />
            <Route path={`${path}/pending`} component={AquaPendingLineList} />
            <Route path={`${path}/:id/history`} component={AquaHistory} />
            <Route path={`${path}/:id/documents`} component={AquaDocument} />
        </Switch>
    );
}  else {
    return (
      <Switch>
        <Route exact path={path} component={List} />
        <Route path={`${path}/add`} component={Add} />
        <Route path={`${path}/upload`} component={Upload} />
        <Route path={`${path}/:id/edit`} component={Edit} />
        <Route path={`${path}/:id/summary`} component={Summary} />
      </Switch>
    );
  }
}

export { MaterialRequests };
